// extracted by mini-css-extract-plugin
export default {"loader":"PastBookings_loader__KdWQF","h1":"PastBookings_h1__jpB3T","wishlist":"PastBookings_wishlist__WG2rj","wishlist1":"PastBookings_wishlist1__k+209"};